import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { authHeaders, http } from './http.js';

async function listCompanies(getToken) {
    const headers = await authHeaders(getToken);
    const { data } = await http.get('/company', { headers });
    return data;
}

async function getCompany(getToken, companyId) {
    const headers = await authHeaders(getToken);
    const { data } = await http.get(`/company/${companyId}`, { headers });
    return data;
}

async function saveCompany(getToken, input) {
    const headers = await authHeaders(getToken);
    const { data } = await http.post('/company', input, { headers });
    return data;
}

export function useCompanies() {
    const { getToken } = useAuth();
    return useQuery({
        queryKey: ['companies'],
        queryFn: () => listCompanies(getToken),
    });
}

export function useCompany(companyId) {
    const { getToken } = useAuth();
    return useQuery({
        queryKey: ['company', companyId],
        queryFn: () => getCompany(getToken, companyId),
        enabled: Boolean(companyId),
    });
}

export function useSaveCompany(onSuccess) {
    const { getToken } = useAuth();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (input) => saveCompany(getToken, input),
        onSuccess: (data) => {
            queryClient.setQueryData(['companies'], (companies) =>
                companies?.some((c) => c.id === data.id)
                    ? companies.map((c) => (c.id === data.id ? data : c))
                    : [...(companies ?? []), data],
            );
            queryClient.setQueryData(['company', data.id], data);
            queryClient.invalidateQueries({ queryKey: ['companies'] });
            onSuccess?.(data);
        },
    });
}